// Leadership & team. Photos for the founders and senior team are hosted on the
// firm's CDN; members without a photo render an on-brand initials avatar.
// NOTE: bios and the titles for Sonal & Sheilla are drafts pending client review.
export const FOUNDERS = [
  {
    name: "Akshay Grover",
    role: "Founder",
    photo:
      "https://cdn.sanity.io/images/3mdwyo8n/production/80acf28028f39a5e1592015efdcfdafc43996f86-624x624.jpg?w=800&h=1000&fit=crop",
    linkedin: "https://www.linkedin.com/in/akshgrov",
    bio: "Founder of AMADI, Akshay leads the firm's cross-border legal and advisory practice across the UAE, the Middle East, and Africa, drawing on years of building and structuring businesses in growth markets.",
  },
  {
    name: "Raghvendra Verma",
    role: "Managing Partner",
    photo:
      "https://cdn.sanity.io/images/3mdwyo8n/production/e3889c903c1ba98cfd3dd9c1544d5efb1de5660e-624x624.jpg?w=800&h=1000&fit=crop",
    linkedin: "https://www.linkedin.com/in/vermaraghvendra",
    bio: "As Managing Partner, Raghvendra leads AMADI's advisory and transactions practice across the UAE, the Middle East, and Africa.",
  },
];

export const TEAM = [
  {
    name: "Nikhil Mitra",
    role: "Principal",
    photo:
      "https://cdn.sanity.io/images/3mdwyo8n/production/19ffb389fb5f8c791a7aee8ee414f9a65e394a56-624x624.jpg?w=700&h=700&fit=crop",
    linkedin: "https://www.linkedin.com/in/nikmitra",
    bio: "Nikhil advises founders and boards on corporate structuring, transactions, and regulatory matters across the UAE and the African corridor.",
  },
  {
    name: "Ian Lumbasio",
    role: "Senior Associate",
    photo:
      "https://cdn.sanity.io/images/3mdwyo8n/production/69ca4042bfc7cb8dd18d65d6c16ce43a63d06680-624x624.jpg?w=700&h=700&fit=crop",
    linkedin: "https://www.linkedin.com/in/ian-lumbasio",
    bio: "Ian supports clients on corporate, commercial, and cross-border matters, with a particular focus on the East Africa market.",
  },
  {
    name: "Mugdha Pandit Grover",
    role: "Director, Marketing",
    photo:
      "https://cdn.sanity.io/images/3mdwyo8n/production/86435f1bed4789b78365445121b176eabe5aeebe-624x624.jpg?w=700&h=700&fit=crop",
    linkedin: "https://www.linkedin.com/in/mugdha-pandit-grover-79ba076",
    bio: "Mugdha leads AMADI's brand, communications, and client experience across the firm's markets.",
  },
  {
    name: "CS Sonal Manchandani",
    role: "Company Secretary",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_amadi-home-build/artifacts/ikf02yg0_Sonal%20passport%20image.png",
    linkedin: "https://www.linkedin.com/in/cs-sonal-manchandani-382839224",
    bio: "A qualified Company Secretary, Sonal supports governance, corporate compliance, and entity administration for the firm's clients.",
  },
  {
    name: "Sheilla Moseti",
    role: "Associate",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_amadi-home-build/artifacts/nsu8cj37_Stella.jpeg",
    linkedin: "https://www.linkedin.com/in/sheilla-moseti-740693175",
    bio: "Sheilla works across corporate and regulatory matters, supporting clients on the ground in the East Africa market.",
  },
];
